__turbopack_context__.v({
  "container": "index-module__vQLkpW__container",
  "coverImage": "index-module__vQLkpW__coverImage",
  "endCircle": "index-module__vQLkpW__endCircle",
  "headerRow": "index-module__vQLkpW__headerRow",
  "imageContainer": "index-module__vQLkpW__imageContainer",
  "srOnly": "index-module__vQLkpW__srOnly",
  "startCircles": "index-module__vQLkpW__startCircles",
  "timeline": "index-module__vQLkpW__timeline",
  "timelineEnd": "index-module__vQLkpW__timelineEnd",
  "timelineGroup": "index-module__vQLkpW__timelineGroup",
  "timelineIconCircle": "index-module__vQLkpW__timelineIconCircle",
  "timelineText": "index-module__vQLkpW__timelineText",
  "timelineTextContainer": "index-module__vQLkpW__timelineTextContainer",
  "timelineTextLong": "index-module__vQLkpW__timelineTextLong",
  "timelineTextShort": "index-module__vQLkpW__timelineTextShort",
  "timelineUnderlay": "index-module__vQLkpW__timelineUnderlay",
  "underlay": "index-module__vQLkpW__underlay",
});
